import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles.css';
import { t } from '../i18n/translationStrings.js';

const Footer = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <footer style={{
      padding: '0.25rem 0.5rem',
      fontSize: '0.65rem',
      backgroundColor: 'var(--background-color)',
      color: 'var(--text-color)',
      textAlign: 'center',
      lineHeight: '1.2',
    }}>
      <p style={{ margin: '0.2rem 0' }}>
        &copy; {new Date().getFullYear()} {t('footerCopyright')}
      </p>

      <nav aria-label="Footer Navigation">
        <ul style={{
          listStyle: 'none',
          padding: 0,
          margin: '0.2rem 0',
          display: 'flex',
          justifyContent: 'center',
          gap: '0.5rem',
          flexWrap: 'wrap'
        }}>
          <li>
            <Link to="/about" style={{ fontSize: '0.65rem', opacity: 0.6 }}>
              {t('about') || 'About'}
            </Link>
          </li>

          <li>
            <Link to="/contact" style={{ fontSize: '0.65rem', opacity: 0.6 }}>
              {t('navContact') || 'Contact'}
            </Link>
          </li>

          <li>
            <Link to="/privacy-policy" style={{ fontSize: '0.65rem', opacity: 0.6 }}>
              {t('privacyPolicy') || 'Privacy Policy'}
            </Link>
          </li>

          <li>
            <Link to="/impressum" style={{ fontSize: '0.65rem', opacity: 0.6 }}>
              {t('impressum') || 'Impressum'}
            </Link>
          </li>
        </ul>
      </nav>

      <p style={{ margin: '0.4rem 0 0', fontSize: '0.7rem', opacity: 0.5, maxWidth: '400px', marginInline: 'auto' }}>
        {t('footerBlurb')}
      </p>
    </footer>
  );
};

export default Footer;